// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_51-2";
export var blackBorderOnHover = "_51-7";
export var cell = "_51-6";
export var cellContainer = "_51-3";
export var checked = "_51-8";
export var disabled = "_51-5";
export var featuredIconCellContainer = "_51-9";
export var featuredIconTextContainer = "_51-b";
export var featuredIconWrapper = "_51-a";
export var noBorder = "_51-c";
export var orangeSelectedRow = "_eg-3";
export var overflowableText = "_51-0";
export var overflowableTextContainer = "_51-1";
export var row = "_53-0";
export var rowCheckboxCell = "_51-4";
export var selectableTable = "_eg-2";